<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="practitioner" sticky>
    <th *matHeaderCellDef mat-header-cell class="w-80">Practitioner</th>
    <td *matCellDef="let record" mat-cell class="w-80">
      <a href="javascript:void(0);" (click)="store.selectSummary(record)">
        {{ record.practitioner.name }}
      </a>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-80 font-bold">
      @if (footerData && footerData.practitioner) {
        {{ footerData.practitioner }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="labFeesAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon>
        Lab Fees
        <mat-icon [matTooltip]="tooltips.labFees">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon>
        {{ record.labFees.total.labFeesAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.labFeesAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="reservedAccountCreditAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon>
        Reserved Account Credits
        <mat-icon [matTooltip]="tooltips.reservedAccountCredit">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon>
        {{ record.accountCredits.total.reservedAccountCreditAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.reservedAccountCreditAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="accountCreditAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon>
        Account Credits Used
        <mat-icon [matTooltip]="tooltips.accountCreditUsed">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon>
        {{ record.transactions.total.accountCreditAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.accountCreditAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="discountAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon>
        Discounts Given
        <mat-icon [matTooltip]="tooltips.discountsGiven">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon>
        {{ record.transactions.total.discountAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.discountAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="paymentAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon>
        Payments
        <mat-icon [matTooltip]="tooltips.payments">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon>
        {{ record.transactions.total.paymentAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.paymentAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="practitionerProportionAmount">
    <th *matHeaderCellDef mat-header-cell class="w-52">
      <pr-value-with-icon
        >Practitioner Proportion
        <mat-icon [matTooltip]="tooltips.practitionerProportion">info</mat-icon>
      </pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell class="w-52">
      <pr-value-with-icon
        [ngClass]="{
          refund: record.transactions.total.practitionerProportionAmount < 0
        }"
      >
        {{ record.transactions.total.practitionerProportionAmount | currency }}
      </pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell class="w-52 font-bold">
      @if (footerData) {
        <pr-value-with-icon>
          {{ footerData.practitionerProportionAmount | currency }}
        </pr-value-with-icon>
      }
    </td>
  </ng-container>

  @if (showHeaders) {
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  }
  <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>

  @if (footerData) {
    <tr *matFooterRowDef="displayedColumns" mat-footer-row></tr>
  }
</table>
